import { Clipboard } from '@chakra-ui/react';

import Button, { ButtonProps } from 'ui/Button';
import Icon from 'ui/Icon';

type Props = Omit<ButtonProps, 'value'> & {
  value: string;
};

const ClipboardButton: React.FC<Props> = ({
  value,
  children,
  ...buttonProps
}) => (
  <Clipboard.Root value={value}>
    <Clipboard.Trigger asChild>
      <Button {...buttonProps}>
        <Clipboard.Indicator
          copied={
            <>
              <Icon icon="check" /> Copied
            </>
          }
        >
          {children}
        </Clipboard.Indicator>
      </Button>
    </Clipboard.Trigger>
  </Clipboard.Root>
);

export default ClipboardButton;
